import { PUT, POST } from '@/api/api'
import { HealthInsurerFormData } from '@/types/healthInsurerFormData'

export const useSaveHealthInsurer = () => {
  const save = async (
    formData: HealthInsurerFormData,
    startDate: string,
    id?: string,
  ) => {
    const applicableDate = new Date(startDate.toString())
    const today = new Date()
    applicableDate.setHours(0, 0, 0, 0)
    today.setHours(0, 0, 0, 0)
    const isPastOrToday = applicableDate <= today

    const isNewEntry = !id
    const shouldUsePost = isNewEntry || isPastOrToday
    const url =
      isNewEntry || isPastOrToday
        ? '/api/health-insurers'
        : `/api/health-insurers/${id}`
    const method = shouldUsePost ? POST : PUT

    return method(url, formData)
  }

  return { save }
}
